/**
 * Amv01 21042025 - Add Warehouse location
 */
import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { StaticDataService } from './services/static-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = "tic-clarity-admin";
  authenticated = false;

  constructor(private authService: AuthService, private staticData: StaticDataService) {

    //deal with login
  }

  ngOnInit() {

    const tokens = (window.location.href).split("/");
    //Amv01
    const warehouse_location = tokens[3];
    //Amv01 End

    // console.log("main: "+ tokens[3]);
    const promise = this.authService.login(tokens.pop(), warehouse_location);

    promise.then(response => {
      this.authenticated = true;
    }).catch(response => {
      window.location.href = "https://login.ticsin.com";      
    });

    this.staticData.init();
  }

  get loadingCompleted() {
    return this.staticData.loadingComplete;
  }

  get bigScreen() {    
    return window.innerWidth ? window.innerWidth > 414 : true;
  }
}
